/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 13:53:53
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:15:19
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import { API, API_URL } from '@/config';

import {
  COMPLETE_LIST,
  TOGGLE_SERVICE_STATUS_CHANGE_RESULT,
  TOOGLE_CHANGE_STATUS_LOADING,
  SET_RESPONSE_CODE,
  TOOGLE_SERVICES_LIST_LOADING,
  COMPLETE_PACKAGE_USAGE,
  TOOGLE_GET_USAGE_LOADING,
  SET_SERVICE_STATUS_CONFIRMATION_REQUIRED,
  CLEAR_SERVICE_STATUS_CONFIRMATION_REQUIRED,
} from './mutation-types';

export default {

  async getServicesList({ commit }) {
    let result = null;
    let status = 200;
    commit(SET_RESPONSE_CODE, { status });
    try {
      commit(TOOGLE_SERVICES_LIST_LOADING);
      result = (await API.get(`${API_URL}/services`));
      const list = result.data.data;
      commit(COMPLETE_LIST, { list });
      status = result.status;
      commit(SET_RESPONSE_CODE, { status });
    } catch (error) {
      status = 500;
      commit(SET_RESPONSE_CODE, { status });
    }
    commit(TOOGLE_SERVICES_LIST_LOADING);
    commit(CLEAR_SERVICE_STATUS_CONFIRMATION_REQUIRED);
  },
  async changeStatus({ commit, dispatch }, data) {
    let result = null;
    try {
      commit(TOOGLE_CHANGE_STATUS_LOADING);
      result = await API.patch(`${API_URL}/service/changeStatus`, { ...data });
      const status = result.status;
      commit(SET_RESPONSE_CODE, { status });
      if (result.data.sms_confirmation_required) {
        commit(SET_SERVICE_STATUS_CONFIRMATION_REQUIRED);
      } else {
        let enabled = result.data.enabled;
        let incorrectCode = result.data.incorrect_code;
        commit(TOGGLE_SERVICE_STATUS_CHANGE_RESULT, { enabled, incorrectCode });
        if (!incorrectCode) {
          dispatch('getServicesList');
        }
      }
    } catch (error) {
      const status = 500;
      commit(SET_RESPONSE_CODE, { status });
    }
    commit(TOOGLE_CHANGE_STATUS_LOADING);
    return result;
  },
  async getPackageUsage({ commit }, params) {
    let result = null;
    try {
      commit(TOOGLE_GET_USAGE_LOADING);
      result = (await API.get(`${API_URL}/package/usage`, { params }));
      const packageUsage = result.data.data;
      const status = result.status;
      commit(SET_RESPONSE_CODE, { status });
      commit(COMPLETE_PACKAGE_USAGE, { packageUsage });
    } catch (error) {
      const status = error.response.status;
      commit(SET_RESPONSE_CODE, { status });
    }
    commit(TOOGLE_GET_USAGE_LOADING);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Services/actions.js